<template>
    <div class="container">
        <div class="seacher">
            <!-- 日期选择器 -->
            <el-form :model="queryParams" ref="queryForm" label-width="110px">
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker size="small" clearable  v-model="queryParams.beginTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择开始时间" :picker-options="startNoTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker size="small" clearable  v-model="queryParams.endTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择结束时间" :picker-options="endNoTime">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <!-- 其他查询 -->
            <el-form :inline="true" class="demo-form-inline" label-width="110px">
                <el-form-item label="提单号查询" prop="radio" >
                    <el-input size="small" clearable v-model.trim="queryParams.blNo" placeholder="请输入提单号"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="委托单位查询">
                    <el-select size="small" filterable clearable v-model="queryParams.customer"
                        placeholder="请选择委托单位">
                        <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <!-- <el-input clearable v-model.trim="queryParams.customer" placeholder="请输入委托单位"
                            style="width: 100%;"></el-input> -->
                    </el-form-item>
                <el-form-item label="备注查询">
                    <el-input size="small" clearable v-model="queryParams.note" placeholder="请输入备注"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="船名查询" >
                    <el-input size="small" clearable v-model="queryParams.vessel" placeholder="请输入船名"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="货物分类查询" >
                    <el-select size="small" filterable clearable v-model="queryParams.category"
                        placeholder="请选择货物分类">
                        <el-option v-for="item in classOption" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务类型" >
                    <el-select size="small" filterable clearable v-model="queryParams.businessType"
                        placeholder="请选择业务类型">
                        <el-option v-for="item in businessTypeList" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label=" ">
                    <el-radio-group v-model="queryParams.isLocked">
                        <el-radio :label="0">未锁定</el-radio>
                        <el-radio :label="1">已锁定</el-radio>
                        <el-radio :label="''">全部</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
            <div style="min-width: 300px;">
                <div>   
                    <el-button size="mini" type="primary" @click="submit">查询</el-button>
                    <el-button size="mini" type="success" @click="add">添加</el-button>
                    <el-button size="mini" type="warning" @click="lock('lock')">锁定</el-button>
                    <el-button size="mini" style="background-color:blueviolet; color: aliceblue;"
                        @click="lock('unlock')">解锁</el-button>
                </div>
                <div style="margin-top: 30px;">
                    <el-radio-group v-model="queryParams.isLocked">
                        <el-radio :label="0">未锁定</el-radio>
                        <el-radio :label="1">已锁定</el-radio>
                        <el-radio :label="''">全部</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="main_height">
            <el-table :data="list" height="100%"  :cell-style="rowStyle" id="tableId" ref="tableId" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
                style=" margin-top: 0px;" :header-cell-style="{ textAlign: 'center' }">
                
                <el-table-column type="selection" width="50">
                </el-table-column>
                <af-table-column label="序号" type="index" width="50" align="center">
                </af-table-column>
                <af-table-column label="单据编号" align="center">
                    <template slot-scope="scope">
                        <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span @click="handleClick(scope.row.id)" :class="{ hoverStyle: true }"
                            style=" cursor: pointer">{{ scope.row.billNo}}</span>
                    </template>
                </af-table-column> 
                <af-table-column label="主提单号" align="center">
                    <template slot-scope="scope">
                        <!-- <i class="iconfont icon-mingcheng"></i> -->
                            <span>{{ scope.row.blNo }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="分提单号" align="center" width="160px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.subBlNo }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="委托单位" align="center" width="140px">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.customer }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="船名" align="center" width="160px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.vessel }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="航次" align="center" width="100px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.voyage }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="货物类型" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.category }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="业务类型" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.businessType }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="客服" align="center" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.tracker }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="单证" align="center" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.csMan }}</span>
                    </template>
                </af-table-column>
                <el-table-column label="ETA" align="center" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.eta }}</span>
                    </template>
                </el-table-column>
                <af-table-column label="送货时间" align="center" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.deliveryDate }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="创建时间" align="center" width="140">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="业务主管" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.manager }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="状态" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ computedStatus(scope.row.isLocked) }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="收款状态" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.receiptStatus }}</span>
                    </template>
                </af-table-column>
                
                <!-- <el-table-column label="操作" width="auto" align="center">
                    <template slot-scope="scope">
                        <el-button round size="small" icon="el-icon-edit" type="warning"
                            @click="amendRow(scope.row)">修改</el-button>
                        <el-button plain size="small" icon="el-icon-delete" type="danger"
                            @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column> -->
                <af-table-column label="操作" width="200"  >
                    <template slot-scope="scope">
                        <el-button v-if=" scope.row.receiptStatus !== '已收款'" @click="payCollection(scope.row)" plain size="mini" type="primary">回款</el-button>
                        <el-button  plain size="mini" type="danger" @click="delorder(scope.row)">删除</el-button>
                    </template>
                </af-table-column>
            </el-table>
        </div> 
        <div style="background-color: white;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 50, 100]" :page-size="10" style="padding: 10px;"
                layout="sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'orderManagement',
    data() {
        return {
            arr: [],
            customOption: [],//委托单位数据
            classOption: [],//货物分类数据
            queryParams: {
                beginTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                blNo: '', //提单号
                vessel: '',//船名
                customer: '',//委托单位
                category: '',//货物分类
                note: '',//备注
                isLocked: '',//锁定
                businessType:'',
            },
            businessTypeList:[], // 业务类型列表
            list: [],
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页显示的数据量
            total: 0, // 总数据量
            condition: '',
            // 开始时间限制范围
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },

        }
    },
    watch: {
        "queryParams.beginTime": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "queryParams.endTime": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        '$route'() {
            this.submit();
        }

    },

    mounted() {
        this.getcustomList();
        this.getClassOption();
        this.getbusinessTypeList()
        this.submit();
    },
    methods: {
        // 获取业务类型列表
        getbusinessTypeList(){
            let value = '业务类型';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.businessTypeList = res.data.data.data;
                }
            })
        },
        lock(val) {
            if (val == 'lock') {
                //锁定
                if (this.arr.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要锁定的订单'
                    })
                } else {
                    let URL = `${url.lockStatus}`
                    req.post(URL, this.arr).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: res.data.message
                            })
                            this.getData(1);
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }

                    })
                }
            } else if (val == 'unlock') {
                if (this.arr.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要解锁的订单'
                    })
                } else {
                    let URL = `${url.unLockStatus}`;
                    req.post(URL, this.arr).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: res.data.message
                            })
                            this.getData(1);
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }

                    })
                }
            }

        },

        handleSelectionChange(val) {
            this.arr = [];
            val.forEach(element => {
                this.arr.push(element.id);
            });
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.isLocked == 1) {
                return 'warning-row';
            } else if (row.isLocked == 0) {
                return 'success-row';
            }
            return '';
        },
        computedStatus(row) {
            if (row == 0) {
                return row = '未锁定';
            } else if (row == 1) {
                return row = '已锁定';
            }
        },
        rowStyle() {
            return "text-align:center";
        },
        search() {
            this.getData(1);

        },
        submit() {
            this.getData(1);
        },
        // 页数发生改变时
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData(this.currentPage);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getData(this.currentPage)

        },
        getData(page) {
            this.currentPage = page;
            let URL = `${url.getBusinessList}/${this.currentPage}/${this.pageSize}`;
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {

                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                }
            })
        },
        //添加
        add() {
            // let routeUrl = this.$router.resolve({
            //     path: "/addDetail",
            // });

            // window.open(routeUrl.href, '_blank');
            const params = {
                path: '/addDetail',
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        //单击单元格
        handleClick(row) {
            const params = {
                path: '/addDetail',
                query: {
                    id: row,
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            // this.$router.push({
            //     path: "/addDetail",
            //     query: { id: row },
            // });

        },
        // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=${this.queryParams.customer}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        // 回款
        payCollection(data){
            this.$confirm('是否确认回款?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.business}/${data.id}`;
                req.put(URL).then(res => {
                    if(res.data.code === 200){
                        this.$message({
                            type: 'success',
                            message: res.data.data
                        });
                        this.submit()
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.data.data
                        });
                    }
                })
            }).catch(() => {
                return    
            });
        },
        delorder(data){
            this.$confirm('是否确认删除此订单', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.deleteBusiness}/${data.id}`;
                req.delete(URL).then(res => {
                    if(res.data.code === 200){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit()
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                })
            }).catch(() => {
                // 取消
            });
        }, 
    }
}
</script>

<style lang="css" scoped>
.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}

body,
html {
    overflow-x: hidden;
}
.container{
    width: 100%;
    height: calc(100vh - 82px);
    display: flex;
    flex-direction: column;
    
}
.seacher{
    padding-top: 10px;
    display: flex;
    /* font-size: calc(15vw * 100 / 1920); */
}
.main_height{
    flex:1;
    /* font-size: calc(15.5vw * 100 / 1920); */
}
.el-form-item {
    margin-bottom: 10px;
}
::v-deep .el-table .warning-row {
    background: rgb(247, 194, 196);
}
::v-deep .el-table .success-row {
    background: #bbecbb;
}
</style>